<template>
  <!-- 信息发布 -->
  <div class="page-solicitation w-100">
    <!-- 列表内容 -->
    <div class="com-list-content" style="margin: 0">
      <!-- 表格 -->
      <div class="table">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :row-key="(row)=>{ return row.schemeId }"
          :data="tableData" :cell-class-name="(item)=>{ if(item.columnIndex==1) return 'g-column-light-box'}">
          <el-table-column label="序号" min-width="8%">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column label="标题" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">
              <a class="m-btn" target="_blank" :href="scope.row.url ">{{  scope.row.title }}</a>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="15%">
            <template slot-scope="scope">{{ scope.row.time }}</template>
          </el-table-column>
        </el-table>

        <!-- <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.page" :page-size="listQuery.count" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div> -->
      </div>
    </div>

  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
export default {
  components: {
    cmpMyExport,
  },
  data() {
    return {
      form: {
        title: '',
        // type: ''
      },
      from: 0,
      listQuery: {
        page: 0,
        count: 20
      },
      total: 0,
      typeList: [],
      tableData: [],
      listLoading: true,
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      // 信息发布列表
      this.$http.get('/applet/index/nbdt', {
        ...this.listQuery,
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          let tempArr = []
          if (res.result.items) {
            for (let i = 0; i < res.result.items.length; i++) {
              if (res.result.items[i].content && res.result.items[i].content.newsItem) {
                res.result.items[i].content.newsItem.map(item => {
                  if (!item.isDeleted) {
                    let time = res.result.items[i].updateTime
                    if (time.length == 10) {
                      time = time * 1000
                    }
                    item.time = this.$common.formatDateString(new Date(time), 'yyyy-MM-dd hh:mm:ss')
                    tempArr.push(item)
                  }
                })
              }
            }
          }
          this.tableData = tempArr
          this.total = res.result.totalCount
        }
      })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.page = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.page = 1
      this.initList()
    },


    // 表格分页
    handleSizeChange(val) {
      this.listQuery.count = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.initList()
    }
  },
  created() {
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
</style>